//  libraries
import React from 'react'

//  components
import DeskTop from './desktop'

export default function OriginDestinationQuote () {
  return <DeskTop />
}
